import styled from 'styled-components';
import { rem,em } from 'polished';
import { media } from 'core/layout';
import { colors, accessibilityBorder, themed } from 'core/theme';

const backgroundColor = (props) => themed(
  Object.assign({}, colors.lightThemed, {
    light: colors.W,
  })
);

const labelColor = (props) => themed(
  Object.assign({}, colors.darkThemed, {
    light: colors.B72,
  })
);



export const StyledFilter = styled.div`
    & + & {
        margin-top: 1em;
    }

    ${media.tabletSmall`
      &:last-child {
        margin-bottom: 4em;
      }
    `};
`;

export const FilterLabel = styled.span`
    font-size: ${rem(18)};
    color: ${colors.subtleText};
    display: inline-block;
    margin-bottom:${rem(12)};
`;



export const StyledFeedback = styled.div`
  font-size: 1rem;
  flex: 0 0 ${(7 / 12) * 100}%;
  width: ${(7 / 12) * 100}%;

  button {
    font-size: inherit;
    margin: 0 0.1em;
    min-width: 0;
    padding: 0.5em;
    transform: translateY(-1px);

    margin:0;


    & > span {
      padding: 0;
    }

    &:focus {
      outline-offset: -2px;
    }
  }

  ${media.tablet`
    font-size: ${rem(14)};
    flex-basis: 100%;
    width: 100%;
  `};


  textarea {
    margin-top:${em(16)};
      background-color: ${backgroundColor};
      border: 1px solid #E0E0E0;  
      border-radius: 2px;
      color: ${colors.text};
      font-size: ${em(16)};
      width: 100%;
      padding: 0.5em 1em;

      &::-webkit-search-cancel-button {
        -webkit-appearance: none;
      }

      &::-ms-clear {
        display: none;
      }

      &:not([value=""]) + label > span {
        // display: none;
      }

      ${accessibilityBorder};
    }


`;



// WEBPACK FOOTER //
// ./src/modules/Feedback/styled.js